<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Survey</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Marketing</b>
      /
      <router-link :to="{name: 'survey-view'}">Survey</router-link>
      /
      <b v-if="edit">Details</b>
      <b v-else>Add</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;">
      <!-- <span style="margin-right: 20px;"><b>Officer:</b> Ali</span> -->
      <!-- <span><b>Date Taken:</b> {{dateTaken | moment("Do MMMM YYYY")}}</span> -->
    </div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Survey Detail</h4>
            <br />
            <div class="row">
              <div class="col-8">
                <label>Survey Name</label>
                <input
                  type="text"
                  class="form-control"
                  style="margin-bottom: 10px;"
                  v-model="surveyName"
                />
                <label>Survey Type</label>
                <v-select
                  style="margin-bottom: 10px;"
                  v-model="surveyType"
                  :options="type"
                  @input="onSurveyTypeChange"
                  :searchable="false"
                >
                </v-select>
                <label>TBM Point</label>
                <input
                  type="number"
                  min="1000"
                  class="form-control"
                  style="margin-bottom: 10px;"
                  v-model="TBMPoint"
                />
              </div>
              <div class="col-4" style="padding: 0px 20px 0px 50px;">
                <label>Activation Status</label>
                <div class="row" style="padding-bottom: 10px;">
                  <label class="radio radio-success ml-3">
                    <input
                      type="radio"
                      name="radio"
                      v-model="active"
                      v-bind:value="a"
                    />
                    <span>Active</span>
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio radio-danger ml-3">
                    <input
                      type="radio"
                      name="radio"
                      v-model="active"
                      v-bind:value="b"
                    />
                    <span>Inactive</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <label v-if="checked">Select Product</label>
                <select
                  v-if="checked"
                  class="form-control"
                  v-model="productSelected"
                  @change="onChangeProductID"
                >
                  <option
                    v-for="(product, index) in products"
                    :key="index"
                    :value="product.id"
                    >{{ product.name }}</option
                  >
                </select>
              </div>
            </div>
            <button
              class="btn btn-primary btn-rounded"
              style="margin-bottom: 20px;"
              @click.prevent="addQuestion"
            >
              Add Question
            </button>
            <div
              class="row"
              id="questionRow"
              v-for="(question, index) in questionsList"
              :key="index"
            >
              <div class="col-8">
                <label>Question {{ index + 1 }}</label>

                <div
                  class="row"
                  style="padding-left: 15px; padding-right: 20px;"
                >
                  <input
                    type="text"
                    class="form-control col-9"
                    style="margin-bottom: 10px;"
                    v-model="question.question"
                  />
                  <span class="col-1"></span>
                  <button
                    class="btn col-1"
                    style="background-color: #8c1919; color: white"
                    @click.prevent="
                      deleteQuestion(index, question.survey_id, question.id)
                    "
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </div>

                <div
                  v-for="(choice, choiceIndex) in question.answers"
                  :key="choiceIndex"
                  style="padding-left: 40px; padding-right: 20px;"
                >
                  <label>Choice {{ choiceIndex + 1 }}</label>
                  <div class="row">
                    <input
                      type="text"
                      class="form-control col-9"
                      style="margin-bottom: 10px;"
                      v-model="question.answers[choiceIndex]"
                    />
                    <span class="col-1"></span>
                    <button
                      class="btn col-1"
                      style="background-color: #8c1919; color: white"
                      @click.prevent="deleteChoice(question, choiceIndex)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <button
                  v-if="question.type != 0 && question.type != 1"
                  class="btn btn-primary btn-rounded"
                  style="margin-bottom: 20px;"
                  @click.prevent="addChoice(question)"
                >
                  Add Choices
                </button>
              </div>
              <div class="col-4" style="padding: 0px 20px 0px 50px;">
                <label>Type</label>
                <br />
                <v-select
                  :options="typeList"
                  v-model="question.questionType"
                  @input="onChange(question)"
                  :searchable="false"
                >
                </v-select>
              </div>
            </div>
            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <button
                  class="btn btn-lg btn-success col-2"
                  @click="submitSurvey()"
                >
                  Save Survey
                </button>
                <span class="col-3"></span>
                <!-- <span class="col-3"></span> -->
                <!-- <button class="btn btn-lg btn-danger col-2">Cancel</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "survey-add",
  mixins: [dateManipulation],
  props: ["edit"],
  components: { vSelect },

  data() {
    return {
      dateTaken: "",
      surveyName: "",
      surveyType: "",
      surveySelected: 0,

      TBMPoint: 0,
      active: 0,
      survey_id: null,
      questionsList: [],
      typeList: ["Open Text", "Multiple Choice", "Checkbox"],
      type: ["Product Purchase Survey", "General"],
      a: 1,
      b: 0,

      productType: "",
      productSelected: "",
      products: [],
      checked: false
    };
  },

  methods: {
    async loadDetails() {
      if (this.$props.edit == false) {
        this.dateTaken = this.todaysDate();
      }

      if (this.$props.edit == true) {
        let id = this.$route.params.id;
        let token = this.checkToken();
        try {
          let result = await axios.get(axios.lpsURL + "/survey/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          result = result.data;

          // console.log(JSON.stringify(result, undefined, 4))
          this.questionsList = result.questions;
          this.surveyName = result.survey_title;
          this.surveySelected = result.type;
          this.active = result.active;
          this.survey_id = id;
          this.TBMPoint = result.points;
          if (this.surveySelected == 1) {
            this.surveyType = "Product Purchase Survey";
            this.checked = true;
          } else {
            this.surveyType = "General";
            this.checked = false;
          }
          for (let i = 0; i < this.questionsList.length; i++) {
            if (this.questionsList[i].type == "1") {
              this.questionsList[i].questionType = "Open Text";
            } else if (this.questionsList[i].type == 2) {
              this.questionsList[i].questionType = "Multiple Choice";
            } else {
              this.questionsList[i].questionType = "Checkbox";
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    addQuestion() {
      const question = {
        id: "",
        question: "",
        questionType: "Open Text",
        type: 1,
        answers: ""
      };
      this.questionsList.push(question);
    },

    addChoice(question) {
      question.answers.push("");
    },

    onChange(question) {
      this.convertType(question);
      if (
        this.checkQuestion(question.questionType) == 2 ||
        this.checkQuestion(question.questionType) == 3
      ) {
        question.answers = [""];
      } else {
        question.answers = "";
      }
    },

    /**
     * Check question type
     * input string
     * return integer
     */
    checkQuestion(str) {
      switch (str) {
        case "Open Text":
          return 1;
        case "Multiple Choice":
          return 2;
        case "Checkbox":
          return 3;
        default:
          return 0;
      }
    },

    /**
     * Convert question type from value to key
     * input string
     * return integer
     */
    convertType(question) {
      switch (question.questionType) {
        case "Open Text":
          question.type = 1;
          break;
        case "Multiple Choice":
          question.type = 2;
          break;
        case "Checkbox":
          question.type = 3;
          break;
        default:
          question.type = 0;
          break;
      }
    },

    /**
     * convert question type to value
     * input integer
     * return string
     */
    convertToValue(int) {
      switch (int) {
        case 1:
          return "Open Text";
        case 2:
          return "Multiple Choice";
        case 3:
          return "Checkbox";
      }
    },

    // Submit Question
    onSubmit() {
      let token = this.checkToken();
      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }
        this.questionsList.forEach(list => {
          if (list.id == null || list.id == "") {
            this.createQuestion(token, list);
          } else {
            this.updateQuestion(token, list);
          }
        });
      });
    },

    // Create Question
    createQuestion(token, list) {
      axios
        .post(
          axios.lpsURL + "/question",
          {
            survey_id: this.$route.params.id,
            questions: [list]
          },
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            swal({ icon: "success", text: res.data.message }).then(ok => {
              console.log("OK");
              this.loadDetails();
            });
          } else {
            swal({ icon: "error", text: res.data.message });
          }
        });
    },

    // Update Question
    updateQuestion(token, list) {
      axios
        .post(
          axios.lpsURL + "/question/update",
          {
            survey_id: this.$route.params.id,
            questions: [list]
          },
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            swal({ icon: "success", text: res.data.message });
          } else {
            swal({ icon: "error", text: res.data.message });
          }
        });
    },

    // Submit Survey
    submitSurvey() {
      let token = this.checkToken();
      let apiUrl = "";
      if (this.$props.edit == true) {
        let id = this.$route.params.id;
        apiUrl = "/survey/update/" + id;
      } else {
        apiUrl = "/survey";
      }

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }

        axios
          .post(
            axios.lpsURL + apiUrl,
            {
              survey_title: this.surveyName,
              description: "survey 1 description",
              type: this.surveySelected,
              active: this.active,
              start_date: "2020-02-11",
              end_date: "2020-02-20",
              points: this.TBMPoint,
              questions: this.questionsList,
              product_id: this.productSelected
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              if (!this.edit) {
                this.loadDetails();
              }
              swal({
                icon: "success",
                text: res.data.message
              }).then(() => {
                // if (!this.edit) {
                //   this.$router.push("edit/" + res.data.survey_id);
                // }

                this.$router.push({name: "survey-view"});
              });
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    // Remove Question
    deleteQuestion(index, survey_id, id) {
      let token = this.checkToken();

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }
        axios
          .post(
            axios.lpsURL + "/question/delete/" + survey_id + "/" + id,
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({ icon: "success", text: res.data.message });

              if (index > -1) {
                this.questionsList.splice(index, 1);
              }
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    // Remove Question Choice
    deleteChoice(question, choiceIndex) {
      if (choiceIndex > -1) {
        question.answers.splice(choiceIndex, 1);
      }
    },

    // Check Token
    checkToken() {
      let token = localStorage.getItem("token");
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;
        return token;
      }
      Swal({
        icon: "error",
        text: "You are not Authorised."
      });
      return;
    },

    // Survey Type changes
    onSurveyTypeChange() {
      if (this.surveyType == "Product Purchase Survey") {
        this.surveySelected = 1;
        this.checked = true;
      } else {
        this.surveySelected = 2;
        this.checked = false;
      }
    },

    async loadProducts() {
      let token = this.checkToken();
      try {
        let result = await axios.get("/products", {
          headers: {
            Authorization: "Bearer " + token
          }
        });

        result = result.data;

        result.forEach(list => {
          this.products.push({ id: list.id, name: list.name });
        });

        // console.log(JSON.stringify(this.products, undefined, 4));
      } catch (error) {
        console.log(error);
      }
    }
  },

  async created() {
    await this.loadProducts();
    await this.loadDetails();
    if (this.$props.edit) {
      this.checked = false;
    }
  },

  mounted() {}
};
</script>
